<mat-label class="subHeading">Success Date<span *ngIf="need" class="star">*</span></mat-label>
<div class="d-flex align-items-center mt-2" style="gap: 10px;">
    <mat-form-field appearance="fill">
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="successDate">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</div>